import WorkSection from "./Work";
import TeamSection from "./Team";
import AboutSection from "./About";

export const Work = WorkSection; // only display of data here
export const Team = TeamSection; // only display of data here
export const About = AboutSection; // only display of data here
